import { render, staticRenderFns } from "./computer.home.page.vue?vue&type=template&id=04724711&scoped=true&"
import script from "./computer.home.page.vue?vue&type=script&lang=js&"
export * from "./computer.home.page.vue?vue&type=script&lang=js&"
import style0 from "./computer.home.page.vue?vue&type=style&index=0&id=04724711&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04724711",
  null
  
)

export default component.exports